import { render, staticRenderFns } from "./UnreadChatButton.vue?vue&type=template&id=206a7227&scoped=true&"
import script from "./UnreadChatButton.vue?vue&type=script&lang=js&"
export * from "./UnreadChatButton.vue?vue&type=script&lang=js&"
import style0 from "./UnreadChatButton.vue?vue&type=style&index=0&id=206a7227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a7227",
  null
  
)

export default component.exports